"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebouncedValue = void 0;
var react_1 = __importStar(require("react"));
var lambda_1 = require("@webnuts/lambda");
var debounce_1 = __importDefault(require("lodash/debounce")); // todo: find a debounce function, that is not from lodash
exports.useDebouncedValue = function (args) {
    // ensure that the number is positive
    if (lambda_1.is.NumberNonNegative(args.debounceTimeout) === false) {
        throw new Error('debounce must be a positive number');
    }
    // The input is controlled, maintain the value from here.
    var _a = react_1.useState(args.value), value = _a[0], setValue = _a[1];
    // Hold a ref to the last event.
    var eventRef = react_1.default.useRef();
    // When we finally debounce, trigger onChange with the event, and clear the ref.
    var debouncedOnChange = react_1.default.useCallback(debounce_1.default(function () {
        var current = eventRef === null || eventRef === void 0 ? void 0 : eventRef.current;
        if (current !== undefined && args.onChange !== undefined) {
            eventRef.current = undefined;
            args.onChange(current);
        }
    }, args.debounceTimeout), [eventRef, args.debounceTimeout]);
    // When the component is unmounted, we should flush the debounced event
    // todo: consider if we should actually call the awaiting event here, otherwise the information might be lost
    react_1.default.useEffect(function () { return function () { return debouncedOnChange.flush(); }; }, [debouncedOnChange]);
    // On change, debounce the change event and store the last change in a ref.
    var onChange = react_1.default.useCallback(function (event) {
        if (args.onChange === undefined) {
            return;
        }
        event.persist();
        eventRef.current = event;
        debouncedOnChange();
        setValue(event.currentTarget.value);
    }, [eventRef, debouncedOnChange, args.onChange]);
    return { value: value, onChange: onChange };
};
